const SvgComputeandServers2 = (props) => (
  <>
    <path fill={props.p20} d="M64 192V0h64v192z" />
    <path fill={props.p10} d="M0 176V32h48v144zM144 176V32h48v144z" />
  </>
);

export default SvgComputeandServers2;
